import { AgChartOptions, AgCharts } from "ag-charts-community";
import { useEffect, useRef } from "react";

import { LoadingIcon } from "../Icon";

interface Props {
  isLoading?: boolean;
  options: AgChartOptions;
}

export default function AgChartsWrapper({ options, isLoading = false }: Props) {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isLoading || !chartRef.current) return;
    const chart = AgCharts.create({
      container: chartRef.current,
      ...options,
    });
    return () => {
      try {
        chart.destroy();
      } catch {
        // Ignore errors during destroy - can happen in test environments
        // where canvas context is not available
      }
    };
  }, [options, isLoading]);

  return (
    <div
      style={{ minHeight: 300, position: "relative", width: "100%" }}
      className="relative flex items-center justify-center"
    >
      {isLoading ? (
        <LoadingIcon className="w-5 h-5" />
      ) : (
        <div ref={chartRef} style={{ height: "100%", width: "100%" }} />
      )}
    </div>
  );
}
